export const getters = {
  getDialogState(state) {
    return state.dialogState;
  },
  getDialogLoading(state) {
    return state.dialogLoading
  }
};
